import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import background from "../assets/login.webp";
import blank_pp from "../assets/blank_pp.webp";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff, FiX,FiMail, FiLock, FiUser, FiUsers  } from "react-icons/fi";
import { FaArrowLeft } from "react-icons/fa";
import { useRegisterUserMutation } from "../store/apis/authApi";
import { useDispatch } from "react-redux";
import { setUser } from "../store/slices/authSlice";
import Modal from "../components/Modal";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfUse from "./TermsOfUse";

function Signupv2() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [organisation, setOrganisation] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [pp, setPP] = useState(blank_pp);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const [signUp, { isLoading }] = useRegisterUserMutation();

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");
    if (!name) return setError("Please enter your name.");
    if (!email) return setError("Please enter your email.");
    if (!organisation) return setError("Please enter your organisation.");
    if (!password) return setError("Please create a password.");
    if (!confirmPassword) return setError("Please confirm your password.");
    if (confirmPassword !== password)
      return setError("Password and confirmed password are not the same.");

    navigate("/contactUs");

    // const newUser = {
    //   name,
    //   email,
    //   organisation,
    //   photo: "",
    //   password,
    //   passwordConfirm: confirmPassword
    // };

    // try {
    //   const response = await signUp(newUser).unwrap();
    //   if (response.status === "success") {
    //     // store user to redux + sessionStorage
    //     dispatch(setUser({
    //       user: response.user,
    //     }));

    //     sessionStorage.setItem("user", JSON.stringify(response.user));
        
    //     navigate("/contactUs");
    //   }
    // } catch (err) {
    //   if (err?.status === 400) {
    //     setError(err.data?.message || "Invalid input.");
    //   } else if (err?.status === 409) {
    //     setError("An account with this email already exists.");
    //   } else {
    //     setError("Unexpected error. Please try again later.");
    //   }
    // }
  };

  return (
    <PageContainer>
      <Helmet>
        <title>Sign Up | SolarAIDD</title>
        <meta name="description" content="Create an account to use our AI-powered defect detection for solar PV EL images." />
        <link rel="canonical" href="https://solaraidd.csir.co.za/signupv2" />
        <meta name="robots" content="noindex, nofollow" />
        </Helmet>

       {/* 🔙 Back Button */}
        <BackButton onClick={() => navigate("/")}>
          <FaArrowLeft size={20} />
          <span>Back</span>
        </BackButton>

       {/* 🔙 Back Button */}
        <BackButton onClick={() => navigate(-1)}>
          <FaArrowLeft size={20} />
          <span>Back</span>
        </BackButton>

      <SignupFormContainer>
        <Title>Create Account</Title>
        {error && <Error>{error}</Error>}

        <Form onSubmit={handleSignup}>
          <InputWrapper>
            <FiUser />
            <Input
              type="text"
              placeholder="Full Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </InputWrapper>
          <InputWrapper>
            <FiMail />
            <Input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </InputWrapper>
          <InputWrapper>
            <FiUsers />
            <Input
              type="text"
              placeholder="Organisation"
              value={organisation}
              onChange={(e) => setOrganisation(e.target.value)}
            />
          </InputWrapper>
          <InputWrapper>
            <FiLock />
            <Input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <ToggleIcon onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </ToggleIcon>
          </InputWrapper>
          <InputWrapper>
            <FiLock />
            <Input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <ToggleIcon
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
            </ToggleIcon>
          </InputWrapper>

          <AcceptButton type="submit" disabled={isLoading}>
            {isLoading ? "Creating Account..." : "Sign Up"}
          </AcceptButton>
        </Form>

        <BottomText>
          Already have an account? <Link onClick={() => navigate('/login')}>Log In</Link>
        </BottomText>
        
        {/* ✅ Terms + Privacy links */}
        <Legal>
          By signing up, you agree to our{" "}
          <a onClick={() => setShowTerms(true)}>Terms of Use</a> and{" "}
          <a onClick={() => setShowPrivacy(true)}>Privacy Policy</a>.
        </Legal>
      </SignupFormContainer>

      {/* ✅ Modal for Terms of Use */}
      <Modal
        isOpen={showTerms}
        onClose={() => setShowTerms(false)}
        title="Terms of Use"
        lastUpdated="September 1, 2025"
        onAccept={() => console.log("✅ Terms accepted")}
      >
        <TermsOfUse/>
      </Modal>
      
      {/* ✅ Modal for Privacy Policy */}
      <Modal
        isOpen={showPrivacy}
        onClose={() => setShowPrivacy(false)}
        title="Privacy Policy"
        lastUpdated="August 15, 2025"
        onAccept={() => console.log("✅ Privacy accepted")}
      >
        <PrivacyPolicy/>
      </Modal>
    </PageContainer>
  );
}

export default Signupv2;

const PageContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  background-image: url(${background});
  background-size: cover;
  background-position: center;
  justify-content: center;
  align-items: center;
`;

const BackButton = styled.button`
  position: absolute;
  top: 30px;
  left: 30px;
  background: rgba(0, 0, 0, 0.4);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.3s;

  &:hover {
    background: rgba(0, 0, 0, 0.6);
  }
`;

// const SignupFormContainer = styled.div`
//   background: rgba(255, 255, 255, 0.1);
//   backdrop-filter: blur(12px);
//   padding: 2.5rem;
//   border-radius: 20px;
//   box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
//   text-align: center;
//   max-width: 400px;
//   width: 100%;
//   color: white;

//   // h2 {
//   //   margin-bottom: 0.5rem;
//   //   font-size: 2rem;
//   // }
//   // p {
//   //   font-size: 0.9rem;
//   //   margin-bottom: 1.5rem;
//   //   color: #f0f0f0;
//   // }
// `;

const SignupFormContainer = styled.div`
  background: linear-gradient(
    145deg,
    rgba(255, 255, 255, 0.15),
    rgba(255, 255, 255, 0.05)
  );
  backdrop-filter: blur(12px);
  padding: 2.5rem;
  border-radius: 20px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.65);
  text-align: center;
  max-width: 400px;
  width: 100%;
  color: white;
  animation: fadeIn 0.6s ease;

  @keyframes fadeIn {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const Title = styled.h2`
  margin-bottom: 20px;
  font-size: 1.8rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  padding: 0.8rem 1rem;
  svg {
    margin-right: 0.8rem;
    color: #fff;
  }
`;

const Input = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  color: white;
  outline: none;
  font-size: 1rem;

  &::placeholder {
    color: #ccc;
  }

  &:focus {
    outline: 2px solid #4da6ff;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 8px;
  }
`;

const ToggleIcon = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #ddd;

  &:hover {
    color: #fff;
  }
`;

const AcceptButton = styled.button`
  width: 100%;
  padding: 14px;
  margin-top: 20px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(90deg, #e55b41, #d94a35);
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: linear-gradient(90deg, #f06a50, #e55b41);
    box-shadow: 0 0 10px rgba(229, 91, 65, 0.6);
  }

  &:active:not(:disabled) {
    transform: scale(0.97);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;


const BottomText = styled.p`
  margin-top: 20px;
  color: #ddd;
`;

const Link = styled.span`
  color: #ffd369;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;


const Error = styled.p`
  color: #ff6b6b;
  font-size: 0.9rem;
  margin-bottom: 10px;
  animation: shake 0.3s ease;

  @keyframes shake {
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-4px); }
    75% { transform: translateX(4px); }
  }
`;

const Legal = styled.div`
  margin-top: 1rem;
  font-size: 0.75rem;
  color: #ddd;
  text-align: center;
  line-height: 1.4;

  a {
    color: #ffd369;
    font-weight: 500;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      text-decoration: underline;
      color: #ffae00;
    }
  }
`;
